export const FEATURED_FILTER = "filters/featured";
export const SEARCH = "filters/search";
